module.exports = __webpack_public_path__ + "static/media/call_me.03147758.jpg";